import { Children, Fragment, ReactNode, isValidElement } from 'react';
import {
  AccordionItem,
  TAccordionItemProps,
} from '@/common/components/Accordion/AccordionItem';
import { Divider } from '@/common/components/Divider/Divider';
import { Heading } from '@/common/components/Heading/Heading';
import { Stack } from '@/common/components/Stack/Stack';
import * as AccordionPrimitive from '@rn-primitives/accordion';

export const AccordionRoot = ({ title, children, type = 'multiple' }: TAccordionRootProps) => {
  const itemsList = Array.isArray(children) ? children : [children];
  const items = itemsList.filter(isValidElement<TAccordionItemProps>);

  return (
    <AccordionPrimitive.Root type={type}>
      <Stack gap="md">
        {title && <Heading level={4}>{title}</Heading>}
        <Stack>
          {Children.map(items, (child, idx) => {
            return (
              <Fragment key={child.props.name ?? idx}>
                <AccordionPrimitive.Item
                  value={child.props.name ?? idx.toString()}
                >
                  {child}
                </AccordionPrimitive.Item>
                {idx < items.length - 1 && <Divider />}
              </Fragment>
            );
          })}
        </Stack>
      </Stack>
    </AccordionPrimitive.Root>
  );
};

export type TAccordionRootProps = {
  type?: 'single' | 'multiple';
  title?: ReactNode;
  children: ReactNode;
};

export const Accordion = { Root: AccordionRoot, Item: AccordionItem };
